<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="S10" color="#000000"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6uam8l6hij31hc0rsq9k.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ufwpjxrpj30ku0rsgnv.jpg"/>
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation">
            <swiper :options="swiperOption" v-if="seletedColor === 1">
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones1" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
            <swiper :options="swiperOption" v-else-if="seletedColor === 2">
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones2" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
            <swiper :options="swiperOption" v-else>
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones3" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
            <!-- 耳机颜色 -->
            <div class="pro_colors">
                律动黑 <i :class="{active: seletedColor == 1}" @click="switchColor(1)"></i>
                灵动红 <i :class="{active: seletedColor == 2}" @click="switchColor(2)"></i> 
                飘逸灰 <i :class="{active: seletedColor == 3}" @click="switchColor(3)"></i> 
            </div>
            <!-- <img src="http://wx3.sinaimg.cn/large/0067mezugy1g5c70sfwutj30l405dmxc.jpg" /> -->
            <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ug4l2nelj31hc07r0tb.jpg"/>
            <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ugh3gpdrj30ku08qq3n.jpg"/>
        </div>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uam938l3j31hc0rster.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6uam9krnwj31hc0rsdht.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uama0zz7j31hc0rsju6.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6uamakfcdj31hc0rsmzn.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uamaxeeej31hc0rsacu.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6uambkvw1j31hc0rsdlk.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6uamc0nstj31hc0rsmz8.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6uamcfvrbj31hc0rsdpb.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6uameok5xj31hc0rsn0n.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uamgj3s8j31hc0rswil.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6uamh6k1jj31hc0rswlk.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6uamhmmmkj31hc0rsgp9.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6uami4hjhj31hc0rsdmq.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6uamioczjj31hc0rs40y.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6uamj0x9jj31hc0kndhg.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ufwq2spoj30ku0rsdh7.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ufwqltnlj30ku0rstab.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ufwr9o26j30ku0rs0uk.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ufws3i2tj30ku0rswim.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ufwsjqp3j30ku0rswgp.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ufwtoekuj30ku0rs0us.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g6ufwub0m1j30ku0rsdjh.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ufwury4jj30ku0rs0ts.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ufwvfx3mj30ku0rs75t.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 1,
            earphones3: ["http://wx4.sinaimg.cn/large/0067mezugy1g6ub3dn0vhj30au0fd3yt.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g6ub3e84k3j306u0f7aa3.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g6ub3evkgxj30di0eft8t.jpg "],
            earphones2: ["http://wx1.sinaimg.cn/large/0067mezugy1g6ub3c7tekj30ay0fk74x.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g6ub3cpbmsj306s0f23yn.jpg", "http://wx4.sinaimg.cn/large/0067mezugy1g6ub3d3wvwj30dp0em0t1.jpg"],
            earphones1: ["http://wx4.sinaimg.cn/large/0067mezugy1g6ub3aeh35j30au0fcjrt.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g6ub3b4kpjj306s0f2gln.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g6ub3blnqej30di0efmxb.jpg"],
            iconList: [{
                icon: require("../../../assets/img/n/icon15.png"),
                title: "高通CSR8645芯片"
            },{
                icon: require("../../../assets/img/n/icon2.png"),
                title: "蓝牙5.0"
            },{
                icon: require("../../../assets/img/n/icon11.png"),
                title: "霍尔开关感应磁吸"
            },{
                icon: require("../../../assets/img/n/icon12.png"),
                title: "内置高配镍钛记忆合金"
            },{
                icon: require("../../../assets/img/n/icon13.png"),
                title: "支持APT-X无损传输"
            },{
                icon: require("../../../assets/img/n/icon6.png"),
                title: "8.5小时无忧续航"
            },{
                icon: require("../../../assets/img/n/icon7.png"),
                title: "人体工学设计"
            },{
                icon: require("../../../assets/img/n/icon8.png"),
                title: "自动记忆配对蓝牙"
            },{
                icon: require("../../../assets/img/n/icon9.png"),
                title: "整机IPX4防水"
            },{
                icon: require("../../../assets/img/n/icon14.png"),
                title: "通话降噪"
            }]
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>
.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/icons/pa_01.jpg);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/icons/pa_02.jpg);
	/* margin-left: 40px; */
}
.pro_animation .pro_colors i:nth-child(3){
	background-image: url(../../../assets/img/icons/pa_03.jpg);
	/* margin-left: 40px; */
}

@media (max-width: 768px) {
    .pro_animation .pro_colors i:nth-child(2), .pro_animation .pro_colors i:nth-child(3){
        margin-left: 0;
    }
    .pro_animation .pro_colors i{
        margin-right: 0.5973rem;
    }
    .pro_animation .pro_colors i:last-child{
        margin-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/products/S/s10.vue